module.exports = __webpack_public_path__ + "static/media/salary.b88420e6.png";